import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';

import account from '../account/reducer';
import addressBook from '../addressBook/reducer';
import auth from '../auth/reducer';
import carts from '../carts/reducer';
import checkout from '../checkout/reducer';
import downloads from '../downloads/reducer';
import feature from '../feature/reducer';
import fundamentals from '../fundamentals/reducer';
import gamedayAccount from '../gamedayAccount/reducer';
import global from '../global/reducer';
import migrate from '../migrate/reducer';
import modal from '../components/modal/reducer';
import navigation from '../navigation/reducer';
import notifications from '../notifications/reducer';
import offline from '../offline/reducer';
import orderDeadlines from '../orderDeadlines/reducer';
import orders from '../orders/reducer';
import orderReturns from '../orders/orderReturns/reducer';
import outages from '../outages/reducer';
import returns from '../orders/returnStatus/reducer';
import returnDetails from '../orders/returnDetails/reducer';
import request from '../util/requestReducer';
import shop from '../shop/reducer';
import staticPage from '../static/reducer';
import toast from '../components/toast/reducer';
import productsInfo from '../productsInfo/reducer';
import user from '../user/reducer';
import { invitations } from '../userManagement/invitations/reducer';
import { requests } from '../requests/reducer';
import { users } from '../userManagement/users/reducer';
import { orderDetailsReport } from '../orders/downloadOrderDetailsReport/reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    account,
    addressBook,
    auth,
    carts,
    checkout,
    downloads,
    feature,
    form,
    fundamentals,
    gamedayAccount,
    global,
    migrate,
    modal,
    navigation,
    notifications,
    offline,
    orderDeadlines,
    orders,
    orderReturns,
    outages,
    productsInfo,
    returns,
    returnDetails,
    request,
    shop,
    staticPage,
    toast,
    user,
    invitations,
    requests,
    users,
    orderDetailsReport
  });
